// extracted by mini-css-extract-plugin
export var defaultWrapper = "_iw-3";
export var downloadButton = "_iw-4";
export var fileContainer = "_iw-9 _iw-7";
export var fileContainerBase = "_iw-7";
export var fileContainerFixedHeight = "_iw-8 _iw-7";
export var fileInfo = "_iw-5";
export var fileInfoWidthRestricted = "_iw-6";
export var fileType = "_iw-1";
export var fileTypeName = "_iw-2";
export var image = "_iw-0";
export var link = "_iw-b";
export var overflowEllipsis = "_iw-a";